import type {Locale} from "@it-s-ai/auth";
import {AUTH_PACKAGE_LOCALES} from "config";
import {DEFAULT_LANGUAGE, SupportedLanguage} from "./constants";

// The app ships more UI locales than @it-s-ai/auth has copy for, so narrow
// before handing a language to the package — see AUTH_PACKAGE_LOCALES for why
// the two lists differ and when they stop differing.
export const toAuthLocale = (lang: SupportedLanguage | string | undefined): Locale =>
    (AUTH_PACKAGE_LOCALES.includes(lang ?? "") ? lang : DEFAULT_LANGUAGE) as Locale;
